import { render, staticRenderFns } from "./Familiestatuut.vue?vue&type=template&id=1ce642ec&scoped=true"
import script from "./Familiestatuut.vue?vue&type=script&lang=js"
export * from "./Familiestatuut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce642ec",
  null
  
)

export default component.exports